import React from "react";
import '../Styles/MissionPage1.scss';
// import {Link} from "react-router-dom";

function MissionPage1() {
   return (
      <div className="missionPage1Content">
         <div className="missionPage1Container">
            <div className="missionPage1Title">
               How We Do Camp:
            </div>
            <div className='missionPage1TextContainer'>
               <div className="missionPage1Text">
                  Camp Connect serves its campers by providing an atmosphere <br></br>
                  where all campers can be free  from distrations and have <br></br>
                  their hearts prepared to hear God's Word as it is preached.<br></br>
                  the Camp Connect camp mission is summarized in the acrostic CAMP:
               </div>
            </div>

         </div>
      </div>
   )
}
export default MissionPage1;
